import axios from 'axios'
import store from '@/store/store'
import swal from 'sweetalert'
// import api from '@/services/Api'
import Config from '../../static/config.json'
export default class ApiService {
    baseUrl = Config.baseUrl + 'api/v1/'

    async get (urlPath, params = null, basicAuth = null) {
        let url = this.baseUrl + urlPath
        // console.log(url)
        let config = this.getConfig(params, basicAuth)
        let response = await this.handleApi(axios.get(url, config))
        return response
    }

    async post (urlPath, body, params = null) {
        let url = this.baseUrl + urlPath
        let config = this.getConfig(params)
        let response = await this.handleApi(axios.post(url, body, config))
        return response
    }

    async patch (urlPath, body, params = null) {
        let url = this.baseUrl + urlPath
        let config = this.getConfig(params)
        let response = await this.handleApi(axios.patch(url, body, config))
        return response
    }

    async handleApi (axiosPromise) {
        return axiosPromise.then(function (response) {
            if (response.data.Message === 'Invallid authetication Token.') {
                store.dispatch('setUser', null)
                swal('', 'Je bent automatisch uitgelogd, omdat je ergens anders bent ingelogd.', 'warning')
            }
            return response.data
        }).catch(error => {
            let response = null
            if (error.response && error.response.data.Message === 'Invallid authetication Token.') {
                store.dispatch('setUser', null)
                swal('', 'Je bent automatisch uitgelogd, omdat je ergens anders bent ingelogd.', 'warning')
            } else if (error.response && error.response.data) {
                response = error.response.data
            }
            return response
        })
    }

    getConfig (params, basicAuth = null) {
        let config = {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        }
        if (params) {
            config.params = params
        }
        if (basicAuth) {
            config.auth = basicAuth
        } else if (store.state.token) {
            config.headers.Authorization = store.state.token
        } else {
            // config.headers.Authorization = ''
        }
        return config
    }
}



// WEBPACK FOOTER //
// ./src/services/ApiService.js